import React from 'react'
import useMacIdAddStyles from './styles'
import { Box, Grid } from '@mui/material'
import CustomTextField from '../../../../components/CustomTextField/CustomTextField'

const MacIdAdd = ({ formik, devicelist }) => {
  const classes = useMacIdAddStyles()
  return (
    <div className={classes.root}>
      <Box
        sx={{
          '& .MuiTextField-root': { m: 1, width: '100%' },
        }}
        noValidate
        autoComplete="off"
      >
        <Grid container spacing={2} className="mb_20">
          <Grid item xs={12} md={4}>
            <div className=" textfield ">
              <CustomTextField
                label="Name of the Bank"
                id="filled-size-small"
                value={
                  formik.values.clientDetails?.billerDetails?.nameOfTheBank
                }
                onChange={(value) =>
                  formik.setFieldValue(
                    `clientDetails.billerDetails.nameOfTheBank`,
                    value.target.value
                  )
                }
              />
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className=" textfield ">
              <CustomTextField
                label="IFSC Code"
                id="filled-size-small"
                value={formik.values.clientDetails?.billerDetails?.ifscCode}
                onChange={(value) =>
                  formik.setFieldValue(
                    `clientDetails.billerDetails.ifscCode`,
                    value.target.value
                  )
                }
              />
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className=" textfield ">
              <CustomTextField
                label="Address of the Bank"
                id="filled-size-small"
                value={
                  formik.values.clientDetails?.billerDetails?.addressOfTheBank
                }
                onChange={(value) =>
                  formik.setFieldValue(
                    `clientDetails.billerDetails.addressOfTheBank`,
                    value.target.value
                  )
                }
              />
            </div>
          </Grid>

          {/* Second Row - 3 columns */}
          <Grid item xs={12} md={4}>
            <div className=" textfield ">
              <CustomTextField
                label="Entity Name"
                id="filled-size-small"
                value={formik.values.clientDetails?.billerDetails?.entityName}
                onChange={(value) =>
                  formik.setFieldValue(
                    `clientDetails.billerDetails.entityName`,
                    value.target.value
                  )
                }
              />
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className=" textfield ">
              <CustomTextField
                label="Entity Address"
                id="filled-size-small"
                value={formik.values.clientDetails?.billerDetails?.entityAddress}
                onChange={(value) =>
                  formik.setFieldValue(
                    `clientDetails.billerDetails.entityAddress`,
                    value.target.value
                  )
                }
              />
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className=" textfield ">
              <CustomTextField
                label="Account Number"
                id="filled-size-small"
                value={
                  formik.values.clientDetails?.billerDetails?.accountNumber
                }
                onChange={(value) =>
                  formik.setFieldValue(
                    `clientDetails.billerDetails.accountNumber`,
                    value.target.value
                  )
                }
              />
            </div>
          </Grid>

          {/* Third Row - 1 column */}
          <Grid item xs={12} md={4}>
            <div className=" textfield ">
              <CustomTextField
                label="Bill To Address"
                id="filled-size-small"
                value={
                  formik.values.clientDetails?.billerDetails?.billToAddress
                }
                onChange={(value) =>
                  formik.setFieldValue(
                    `clientDetails.billerDetails.billToAddress`,
                    value.target.value
                  )
                }
              />
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}

MacIdAdd.propTypes = {}

export default MacIdAdd
